'use strict';

export default {
    SUCCESS : {errorCode: "00", errorDesc: "Success", friendlyDesc: "הצלחה"},
    NO_RESULT : {errorCode: "11", errorDesc: "No data received", friendlyDesc: "לא התקבלו נתונים"},
    INVALID_TOKEN : {errorCode: "ER090", errorDesc: "Invalid token", friendlyDesc: "טוקן לא תקין"},
    INTERFACE_ERROR : {errorCode: "90", errorDesc: "Interface error", friendlyDesc: "שגיאת ממשק"},
    GENERAL_ERROR : {errorCode: "99", errorDesc: "הפעולה נכשלה, אנא נסה שנית.", friendlyDesc: "שגיאה כללית"},
    UNAUTHORIZED : {errorCode: "10", errorDesc: "UNAUTHORIZED", friendlyDesc: "לא מזוהה"},
    CONNECTION_ERROR : {errorCode: "12", errorDesc: "CONNECTION_PROBLEM", friendlyDesc: "בעיית התחברות לרשת, אנא נסה שוב."},
};